const styles = (theme) => ({
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: -25,
    marginTop: -25,
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  avatar: {
    backgroundColor: theme.palette.background.lighter,
    color: theme.palette.custom.maintenance,
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  buttons: {
    marginTop: theme.spacing.unit * 3,
  },
  buttonsRight: {
    textAlign: 'right',
  },
  buttonsNext: {
    marginLeft: theme.spacing.unit,
  },
  jobCommentsLabel: {
    marginTop: theme.spacing.unit * 2.25,
    letterSpacing: 'unset',
    fontSize: '1.25rem',
  },
  jobCommentsInput: {
    fontSize: '1.375rem !important',
  },
  jobCommentsHelpText: {
    marginTop: theme.spacing.unit,
  },
  jobCommentsTermsText: {
    marginTop: theme.spacing.unit * 2,
  },
  jobCommentsBottomDivider: {
    marginTop: theme.spacing.unit * 2.25,
    marginBottom: theme.spacing.unit * 4,
  },
  jobSummaryLabel: {
    marginTop: theme.spacing.unit * 2.25,
    letterSpacing: 'unset',
  },
  jobSummaryLimit: {
    marginTop: theme.spacing.unit * 3,
  },
  timeFieldContainer: {
    maxWidth: 300,
  },
  timeFieldHeader: {
    marginTop: theme.spacing.unit * 2,
  },
  availabilityColumn: {
    textAlign: 'center',
    alignSelf: 'center',
  },
  confirmationLabel: {
    marginTop: theme.spacing.unit * 2.25,
    marginBottom: theme.spacing.unit * 0.75,
    '& + label': {
      borderBottom: 'none',
      marginLeft: `-${theme.spacing.unit * 1.5}px`,
      '&:first-of-type': {
        borderTop: 'none',
      },
    },
  },
  formControl: {
    '& label': {
      color: `${theme.palette.text.dark} !important`,
      fontSize: '1.25rem',
    },
  },
  dialogText: {
    marginTop: theme.spacing.unit,
  },
  requiredField: {
    '& > label::after, & > .label::after': {
      content: "'*'",
      whiteSpace: 'nowrap',
    },
  },
  bold: {
    fontWeight: 500,
  },
  buttonYesNo: {
    borderWidth: '1px',
    borderColor: theme.palette.primary.dark,
    borderStyle: 'solid',
    borderRadius: 0,
    color: theme.palette.text.dark,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
    },
    '&:first-of-type': {
      borderRadius: '5px 0 0 5px',
    },
    '&:last-of-type': {
      borderRadius: '0 5px 5px 0',
    },
    padding: '4px 40px',
    [theme.breakpoints.up('sm')]: {
      padding: '4px 80px',
    },
    '&:disabled': {
      color: theme.palette.text.dark,
    },
  },
  buttonActive: {
    color: theme.palette.text.white,
    backgroundColor: theme.palette.primary.dark,
  },
});

export default styles;
